import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { PanelState } from "@store/doc-viewer/panel/panel-state";

export const PanelActions = createActionGroup({
	source: 'CodingSection',
	events: {
		'Expand Panel': props<{ panelId: string }>(),
		'Collapse Panel': props<{ panelId: string }>(),
		'Load Panel States': emptyProps(),
		'Set Panel States': props<{ panelStates: Record<string, PanelState> }>(),
	},
});
